let panelZCounter = 30;

export const getNextPanelZIndex = () => {
  panelZCounter += 1;
  return panelZCounter;
};

/**
 * Portaled UI (e.g. behavior insert palette) must sit above every {@link DraggablePanel},
 * which uses ever-increasing z-indices from {@link getNextPanelZIndex}.
 */
export const PORTAL_ABOVE_ALL_PANELS_Z = 500_000;

/**
 * Help/tooltips — above {@link PORTAL_ABOVE_ALL_PANELS_Z} and panel stacking contexts
 * (e.g. {@link DraggablePanel} `backdrop-filter` / `transform`).
 */
export const PORTAL_TOOLTIP_Z = 900_000;

let tooltipPortalRootEl = null;

/**
 * Mount target for {@link createPortal} tooltips — single high-z layer, kept last on `document.body`
 * so other portaled UI does not paint on top.
 */
export function getTooltipPortalRoot() {
  if (typeof document === "undefined") return null;
  let el = tooltipPortalRootEl;
  if (!el || !el.isConnected) {
    el = document.getElementById("critter-tooltip-portal-root");
    if (!el) {
      el = document.createElement("div");
      el.id = "critter-tooltip-portal-root";
      el.setAttribute("aria-hidden", "true");
      Object.assign(el.style, {
        position: "fixed",
        inset: "0",
        pointerEvents: "none",
        zIndex: String(PORTAL_TOOLTIP_Z),
        isolation: "isolate",
      });
      document.body.appendChild(el);
    }
    tooltipPortalRootEl = el;
  }
  if (el.parentNode === document.body && el !== document.body.lastElementChild) {
    document.body.appendChild(el);
  }
  return el;
}
